export default "__VITE_ASSET__1c80b920__"